/**
 * Validates if a value is a valid positive integer ID
 *
 * @param value - The value to validate
 * @returns true if the value is a valid positive integer, false otherwise
 *
 * @example
 * isValidIntegerId(123) // true
 * isValidIntegerId("456") // true
 * isValidIntegerId(0) // false
 * isValidIntegerId(-1) // false
 * isValidIntegerId(null) // false
 * isValidIntegerId(undefined) // false
 * isValidIntegerId("") // false
 * isValidIntegerId("abc") // false
 * isValidIntegerId(123.45) // false
 * isValidIntegerId(NaN) // false
 * isValidIntegerId([]) // false
 * isValidIntegerId({}) // false
 */
export const isValidIntegerId = (value: any): boolean => {
  // Explicitly check for null, undefined, empty string, or non-primitive types first
  if (value == null || value === "" || typeof value === "object") {
    return false;
  }

  // Convert to number and check if it's a positive integer
  const numValue = Number(value);
  return Number.isInteger(numValue) && numValue > 0;
};
